module.exports = __webpack_public_path__ + "img/stockNoData.6f59f335.png";